// Shared by generation and client foot effects without importing the map builder into the browser.
export const DAPPLED_GRASS_START = 64
export const DAPPLED_GRASS_WIDTH = 4
export const CLASSIC_GRASS_TILE = 353
export const QUIET_GRASS_START = 80
export const GRASS_TRANSITION_START = 96
// Dense + quiet textures and fourteen corner combinations, each with sixteen texture phases.
export const FOREST_GRASS_TILE_COUNT = 256
export const FOREST_GRASS_GID = 116000
export const FOREST_GRASS_BLEND_COUNT = 4096
export const FOREST_GRASS_LEVELS = { dense: 0, medium: 1, quiet: 2, border: 3 } as const

/** Four density choices at each shared corner, sixteen spatial texture phases per combination. */
export const blendedForestGrassTile = (x: number, y: number, corners: number[]): number =>
    (corners[0] + corners[1] * 4 + corners[2] * 16 + corners[3] * 64) * 16 +
    (y % DAPPLED_GRASS_WIDTH) * DAPPLED_GRASS_WIDTH + x % DAPPLED_GRASS_WIDTH

export const forestGrassTile = (x: number, y: number, quietCorners = 0): number => {
    const phase = (y % DAPPLED_GRASS_WIDTH) * DAPPLED_GRASS_WIDTH + x % DAPPLED_GRASS_WIDTH
    const start = quietCorners === 0 ? DAPPLED_GRASS_START : quietCorners === 15 ? QUIET_GRASS_START
        : GRASS_TRANSITION_START + (quietCorners - 1) * 16
    return start + phase
}
